import React from "react";
import { Link } from "react-router-dom";

export const LegalLayout = ({ title, lastUpdated, children, testid }) => (
  <div data-testid={testid} className="max-w-3xl mx-auto px-6 md:px-8 py-20 md:py-28">
    <Link to="/" className="label-xs ssm-underline-link mb-8 inline-block">← Back to home</Link>
    <div className="label-xs mb-3">Legal</div>
    <h1 className="font-display text-5xl md:text-6xl font-medium leading-[0.95] mb-4">{title}</h1>
    <p className="text-xs text-neutral-500 mb-12">Last updated: {lastUpdated}</p>
    <div className="prose prose-neutral max-w-none text-neutral-700 leading-relaxed space-y-6">
      {children}
    </div>
  </div>
);

export const H2 = ({ children }) => (
  <h2 className="font-display text-2xl md:text-3xl font-medium text-black mt-10 mb-3">{children}</h2>
);

export const P = ({ children }) => <p className="text-[15px] leading-relaxed">{children}</p>;

export const UL = ({ children }) => <ul className="list-disc pl-5 space-y-1 text-[15px]">{children}</ul>;
